<template>
  <div>
    <common-header></common-header>
    <div class="normal-list">
      <!-- 顶部操作栏：返回 / 创建活动 -->
      <div class="topbar">
        <div class="topbar-back" @click="goBack">‹ 返回</div>
        <div class="topbar-create" @click="goCreate">+ 创建活动</div>
      </div>

      <!-- tag 切换 -->
      <div class="tabs">
        <div
          class="tab"
          :class="{ active: query.status === 0 }"
          @click="switchTab(0)"
        >
          待开奖
        </div>
        <div
          class="tab"
          :class="{ active: query.status === 2 }"
          @click="switchTab(2)"
        >
          已结束
        </div>
      </div>

      <!-- 列表 -->
      <div class="list" v-loading="loading && query.page === 1">
        <div class="card" v-for="item in list" :key="item.id || item.lottery_id">
          <div class="card-body">
            <div class="card-title">{{ item.title || item.name || '通用抽奖活动' }}</div>
            <div class="card-meta">
              <span class="meta-item">开奖方式：{{ prizeTypeText(item.prize_type) }}</span>
              <span class="meta-item" v-if="item.prize_type === 2">满{{ item.auto_prize_num  }}人开奖</span>
              <span class="meta-item" v-if="item.prize_type === 1">{{ item.auto_prize_time  }}自动开奖</span>
           
            </div>

          </div>
          <div class="card-status">
            <span class="status-tag waiting" @click="goDetail(item)">
              大屏互动
            </span>
            <span class="status-tag" :class="query.status === 0 ? 'waiting' : 'ended'">
              {{ query.status === 0 ? '待开奖' : '已结束' }}
            </span>
          </div>
        </div>

        <!-- 空状态 -->
        <div class="empty" v-if="!loading && list.length === 0">
          <p>暂无{{ query.status === 0 ? '待开奖' : '已结束' }}的活动</p>
        </div>

        <!-- 加载状态 -->
        <div class="load-more" v-if="list.length > 0">
          <span v-if="loading && query.page > 1">加载中...</span>
          <span v-else-if="finished">没有更多了</span>
        </div>
      </div>
    </div>
    <common-footer></common-footer>
    <LoginBox ref="login"></LoginBox>

    <!-- 通用抽奖创建提示弹窗 -->
    <el-dialog
      title="创建通用抽奖"
      :visible.sync="showNomarlDialog"
      width="360px"
      center
    >
      <div class="nomarl-dialog" style="text-align: center;">
        <p class="nomarl-tip" style="font-size: 14px;color: #4a4a57;line-height: 1.8;margin: 4px 0 18px;">PC端暂不支持通用抽奖活动创建，<br />请扫码移步手机端创建。</p>
        <img :src="require('@/assets/image/code_create.jpg')" class="code_create" alt="小程序码" style="  width: 180px;height: 180px; border-radius: 8px; object-fit: contain;" />
        <p class="nomarl-sub" style=" font-size: 12px;color: #9a9aa6;margin-top: 12px;">微信扫一扫，手机端快速发起</p>
      </div>
      <div class="tips flex justify-center align-center" style="margin-top: 50px;">
        <!-- <el-button type="primary" class="btn" @click="goGeneralList">我的发起记录</el-button> -->
        <el-button class="btn" @click="showNomarlDialog = false">知道了</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import { getMyList2 } from '../api/api'
import CommonHeader from './header.vue'
import CommonFooter from './footer.vue'
import LoginBox from './loginBox.vue'
export default {
  name: 'normalList',
  data() {
    return {
      list: [],
      loading: false,
      finished: false, // 是否已加载完全部数据
      query: {
        type: 1,
        status: 0, // 0待开奖 2已结束
        page: 1,
        perpage: 10
      },
      showNomarlDialog: false
    }
  },
  components: {
    CommonHeader,
    CommonFooter,
    LoginBox
  },
  methods: {
    goDetail(item) {
      const id = item.lid
      window.open(`/#/nomarldetail?id=${id}`)
    },
    // 返回上一页（通常为活动模型页）
    goBack() {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.push('/models')
      }
    },
    // 跳转到创建活动页
    goCreate() {
      // this.$router.push('/create');
       this.showNomarlDialog = true
    },
    /**
     * 拉取列表数据
     * @param {Boolean} isLoadMore 是否为滚动加载更多（追加），否则为重新加载（覆盖）
     */
    fetchData(isLoadMore = false) {
      if (this.loading) return
      this.loading = true
      getMyList2(this.query, this.$cookie.getCookie('token')).then(
        (res) => {
          const items = this.parseList(res)
          if (isLoadMore) {
            this.list = this.list.concat(items)
          } else {
            this.list = items
          }
          // 返回条数小于每页数量，说明没有更多了
          if (items.length < this.query.perpage) {
            this.finished = true
          }
          this.loading = false
        },
        (reject) => {
          this.loading = false
        }
      )
    },
    /**
     * 兼容多种返回结构，提取列表数组
     */
    parseList(res) {
      if (!res) return []
      const d = res.data != null ? res.data : res
      if (Array.isArray(d)) return d
      if (d.list && Array.isArray(d.list)) return d.list
      if (d.data && Array.isArray(d.data)) return d.data
      if (d.data && d.data.list && Array.isArray(d.data.list)) return d.data.list
      if (d.data && d.data.data && Array.isArray(d.data.data)) return d.data.data
      return []
    },
    /**
     * 开奖方式文案
     */
    prizeTypeText(type) {
      const map = { 1: '按时间开奖', 2: '按人数开奖', 3: '手动开奖' }
      return map[type] || '--'
    },
    /**
     * 切换 tag
     */
    switchTab(status) {
      if (this.query.status === status) return
      this.query.status = status
      this.query.page = 1
      this.list = []
      this.finished = false
      this.fetchData(false)
    },
    /**
     * 滚动到底部加载更多
     */
    handleScroll() {
      if (this.loading || this.finished) return
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      const clientHeight = document.documentElement.clientHeight || window.innerHeight
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      // 距底部 100px 内触发
      if (scrollTop + clientHeight >= scrollHeight - 100) {
        this.query.page += 1
        this.fetchData(true)
      }
    }
  },
  mounted() {
    if (this.$cookie.getCookie('token') === '') {
      this.$refs.login.login_fn()
    } else {
      this.fetchData(false)
    }
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>
<style lang="scss" scoped>
.normal-list {
  width: 1200px;
  margin: 24px auto 60px;
  min-height: 60vh;
}
.topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  .topbar-back {
    font-size: 15px;
    color: #674eff;
    cursor: pointer;
    padding: 8px 18px;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.05);
    transition: all 0.25s;
    &:hover {
      color: #fff;
      background: linear-gradient(135deg, #674eff, #9b7bff);
    }
  }
  .topbar-create {
    font-size: 15px;
    color: #fff;
    cursor: pointer;
    padding: 8px 22px;
    border-radius: 8px;
    background: linear-gradient(135deg, #674eff, #9b7bff);
    box-shadow: 0 4px 18px rgba(103, 78, 255, 0.18);
    transition: all 0.25s;
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 22px rgba(103, 78, 255, 0.28);
    }
  }
}
.tabs {
  display: flex;
  background: #fff;
  border-radius: 12px;
  padding: 8px;
  margin-bottom: 20px;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.05);
  .tab {
    padding: 10px 28px;
    margin-right: 12px;
    font-size: 15px;
    color: #666;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.25s;
    &:hover {
      color: #674eff;
    }
    &.active {
      color: #fff;
      background: linear-gradient(135deg, #674eff, #9b7bff);
    }
  }
}
.list {
  .card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    border-radius: 12px;
    padding: 20px 24px;
    margin-bottom: 16px;
    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.05);
    transition: all 0.25s;
    &:hover {
      box-shadow: 0 6px 22px rgba(103, 78, 255, 0.12);
      transform: translateY(-2px);
    }
    .card-body {
      flex: 1;
      min-width: 0;
    }
    .card-title {
      font-size: 17px;
      font-weight: 600;
      color: #1f1f2c;
      margin-bottom: 12px;
    }
    .card-meta {
      display: flex;
      gap: 32px;
      margin-bottom: 8px;
      .meta-item {
        font-size: 13px;
        color: #8a8a99;
      }
    }
    .card-status {
      flex-shrink: 0;
      margin-left: 24px;
      .status-tag {
        display: inline-block;
        padding: 6px 16px;
        border-radius: 16px;
        font-size: 13px;
        &.waiting {
          color: #674eff;
          background: #f0ecff;
        }
        &.ended {
          color: #999;
          background: #f2f2f5;
        }
      }
    }
  }
}
.empty {
  text-align: center;
  padding: 80px 0;
  color: #b0b0bb;
  font-size: 14px;
}
.load-more {
  text-align: center;
  padding: 16px 0;
  color: #b0b0bb;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/nomarlList.vue